import {captureError} from '../../../utils/log';
import {startError, startLoading} from '../../../utils/reducer';

export default (state, action) => {
  switch (action.type) {
    case 'UPDATE_DEPOSITOR':
      return {
        ...state,
        depositor: {
          isActive: action.depositor,
          loading: false
        }
      };
    case 'UPDATE_CLIENTS':
      return {
        ...state,
        clients: {
          ...state.clients,
          list: action.clients,
          totalCount: action.totalCount,
          loading: false
        }
      };
    case 'UPDATE_INVITATIONS':
      return {
        ...state,
        sentInvitations: {
          ...state.sentInvitations,
          list: action.sentInvitations,
          loading: false
        }
      };
    case 'UPDATE_DOSSIER_STATE_COUNTRY':
      return {
        ...state,
        clients: {
          ...state.clients,
          dossierCountry: action.country
        }
      };
    case 'START_LOADING_ALL':
      return startLoading(state, Object.keys(state));
    case 'START_LOADING':
      return startLoading(state, action.keys);
    case 'ERROR':
      return startError(state, action.key);
    default:
      captureError('Invalid action type on clients reducer');
  }

  return false;
};
